import { Component, ojs, payload, app } from "modular-openscriptjs";
import { dom, tool } from "../../fotastart";
import {
	either,
	eParse,
	isMobile,
	inform,
	cleanDispose,
	uniqueId
} from "../../helpers";
import ProfilePic from "../ProfilePic";
import TextArea from "../Blocks/TextArea";
import OffcanvasBody from "../Offcanvas/OffcanvasBody";
import ModalBody from "../Modals/ModalBody";
import { STRINGS } from "../../declarations";

const h = app("h");
const gc = app("gc");
const broker = app("broker");
const $e = app("$e");

ojs(ProfilePic, TextArea, OffcanvasBody, ModalBody);

export default class CommentReplyForm extends Component {
	holder = null;
	button = null;

	render(comment, ...args) {
		let user = comment.author;
		let id = `crf-id-${uniqueId()}`;

		return h.div(
			{ class: "d-flex flex-column" },

			// Header with Title
			h.div(
				{
					class: "d-flex align-items-center justify-content-between mb-4",
				},
				h.span({ class: "fs-5 fw-bold text-dark" }, "Reply to comment")
			),

			// Original Comment Context
			h.div(
				{
					class: "d-flex gap-3 mb-4 p-3 rounded-4 bg-light border border-light-subtle",
				},
				h.div(
					{ class: "flex-shrink-0" },
					h.div(
						{
							class: "rounded-circle border border-2 border-white shadow-sm overflow-hidden",
							style: "width: 32px; height: 32px;",
						},
						h.ProfilePic(user, {
							class: "w-100 h-100 object-fit-cover",
						})
					)
				),
				h.div(
					{ class: "d-flex flex-column" },
					h.div(
						{ class: "d-flex align-items-center gap-2 mb-1" },
						h.span(
							{ class: "fw-bold text-dark fs-sm" },
							user?.display_name
						),
						h.span(
							{ class: "text-secondary fs-xsm" },
							"@",
							user?.username
						)
					),
					h.fromString(comment?.content, "div", {
						class: "text-secondary text-break fs-sm line-clamp-2",
					})
				)
			),

			// Current User Identity (Replying as...)
			h.div(
				{ class: "d-flex align-items-center gap-2 mb-3 px-1" },
				h.ProfilePic(gc.user, {
					class: "rounded-circle border border-light-subtle",
					style: "width: 24px; height: 24px; object-fit: cover;",
				}),
				h.span(
					{ class: "text-secondary fs-xsm" },
					"Replying as ",
					h.span(
						{ class: "fw-bold text-dark" },
						gc.user?.value?.username
					)
				)
			),

			// Input Area
			h.TextArea({
				class: "form-control p-3 fs-5 border border-secondary-subtle rounded-4 mb-4 shadow-sm",
				style: "min-height: 120px; resize: none;",
				placeholder: "Write your reply...",
				notice_mentions: true,
				notice_hashtags: true,
				ta_hook: id,
				listeners: {
					input: function () {
						let value = this.textContent;
						if (value.length <= 400) return;

						inform(
							`Limit exceeded. Will be truncated`,
							STRINGS.WARNING
						);
					},
				},
			}),

			// Actions
			h.div(
				{ class: "d-flex justify-content-end gap-2" },
				h.button(
					{
						class: "btn btn-light rounded-pill px-4 fw-medium",
						onclick: this.method("closeForm"),
					},
					"Cancel"
				),
				h.button(
					{
						class: "btn btn-primary rounded-pill px-4 fw-bold shadow-sm d-flex align-items-center gap-2",
						onclick: this.method("submitComment", [
							id,
							comment.id,
							"${this}",
						]),
					},
					h.span("Reply"),
					h.i({ class: "fas fa-paper-plane fs-xsm" })
				)
			),

			...args
		);
	}

	$$comment = {
		needs: {
			replyForm: (ed, event) => this.showForm(ed, event),
		},

		is: {
			repliedTo: (ed, event) => {
				this.closeForm();
			},
		},

		has: {
			replyError: (ed, event) => {
				dom.put("Reply", this.button);
				dom.enable(this.button);
			},
		},
	};

	async showForm(ed, event) {
		if (this.holder) {
			cleanDispose(this.holder);
		}

		let data = eParse(ed);
		const comment = data.message.get("comment", 0);

		if (isMobile()) {
			this.holder = tool.offcanvas(
				h.OffcanvasBody(h.CommentReplyForm(comment))
			);
		} else {
			this.holder = tool.plainModal(
				h.ModalBody(h.CommentReplyForm(comment))
			);
		}

		this.holder.show();
	}

	closeForm() {
		this.holder.hide();
	}

	submitComment(hook, commentId, button) {
		this.button = button;
		dom.disable(this.button);

		// Store original content
		this.originalButtonContent = button.innerHTML;
		h.Spinner({ parent: this.button, resetParent: true });

		let input = dom.get(`[ta-hook="${hook}"]`);
		let comment = input?.methods()?.value();

		broker.send(
			$e.comment.needs.to.saveReply,
			payload({ commentId, comment })
		);
	}
}
